/* global Tena */

(function($) {
    'use strict';

    Tena.tenaBar = {
        init: function() {
            var $dropDown = $('.inner-drop-down'),
                $tab = $('.drop-down-tab'),
                $box = $dropDown.find('.pushbox-content');

            $tab.click(function() {
                $('html, body').animate({
                    scrollTop: $('html').offset().top
                });
                $dropDown.slideToggle(function() {
                    if ($dropDown.is(':visible')) {
                        $tab
                            .find('i')
                            .removeClass('icon-nav-arrow-down')
                            .addClass('icon-nav-arrow-up');
                        $tab.addClass('push-down');
                        Tena.Alignment.alignAdjacentItems($box);
                        Tena.Alignment.alignPushboxContentToBottom($dropDown);
                    } else {
                        $tab.removeClass('push-down');
                        $tab
                            .find('i')
                            .removeClass('icon-nav-arrow-up')
                            .addClass('icon-nav-arrow-down');
                    }
                });
            });
        }
    };
})(jQuery);
